import { configureStore } from '@reduxjs/toolkit';
import { logger } from 'redux-logger/src';
import createSagaMiddleware from 'redux-saga';

import rootReducer from './reducers';
import watch from './sagas';

const reducer = rootReducer;
const sagaMiddleware = createSagaMiddleware();

export const store = configureStore({
  reducer,
  middleware: (getDefaultMiddleware) => getDefaultMiddleware(logger).concat(sagaMiddleware),
  devTools: process.env.NODE_ENV === 'development',
});

sagaMiddleware.run(watch);
